import { render, staticRenderFns } from "./AuditLogsListRow.vue?vue&type=template&id=69ffe0bf&scoped=true&"
import script from "./AuditLogsListRow.vue?vue&type=script&lang=js&"
export * from "./AuditLogsListRow.vue?vue&type=script&lang=js&"
import style0 from "./AuditLogsListRow.vue?vue&type=style&index=0&id=69ffe0bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ffe0bf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VCard,VCardText,VCardTitle,VMenu})
